import React, { FC } from "react";
import { CardActionsProps } from "@material-ui/core/CardActions";
import { StyledMuiCardActions } from './styles';

export type Props = {
  children?: React.ReactNode;
};

const CardActions: FC<CardActionsProps> = (props) => {
  return (
    <StyledMuiCardActions {...props} />
  );
};

export default CardActions;
